import { GetFulfillmentOrderTripDetailsForAdminState } from './getFulfillmentOrderTripDetailsForAdmin.types'

const initialState: GetFulfillmentOrderTripDetailsForAdminState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
